import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'

import Expand from '@components/Icon/Expand'
import Collapse from '@components/Icon/Collapse'
import Check from '@components/Icon/Check'
import Dash from '@components/Icon/Dash'

class AccountsOfficesTable extends Component {
  static propTypes = {
    accounts: PropTypes.object,
    sidebarStore: PropTypes.object
  }

  renderOffices = account => {
    return account.offices.map(office => {
      return (
        <tr
          key={office.id}
          className='office-row'
          onClick={() =>
            this.props.sidebarStore.openSidebar({
              template: 'client-office',
              id: office.id
            })
          }
        >
          <td>
            <span className='text-wrapper office-name'>
              {office.officeName}
            </span>
          </td>
          <td>
            <span className='text-wrapper'>{office.country}</span>
          </td>
          <td>
            <span className='text-wrapper' />
          </td>
          <td>
            <span className='text-wrapper'>{office.openProjectCount}</span>
          </td>
          <td>
            <span className='text-wrapper' />
          </td>
          <td>
            <span className='text-wrapper' />
          </td>
        </tr>
      )
    })
  }

  render () {
    const { accounts } = this.props
    return (
      <table className='table-wrapper invoice-table accountsoffices'>
        <thead>
          <tr>
            <th>Account/Office name</th>
            <th>Country</th>
            <th>Atheneum company</th>
            <th>Open projects</th>
            <th>Active contracts</th>
            <th>Guidelines</th>
          </tr>
        </thead>
        {accounts.map(account => {
          return (
            <tbody key={account.id}>
              <tr
                className='account-row'
                onClick={() =>
                  this.props.sidebarStore.openSidebar({
                    template: 'client-account',
                    id: account.id
                  })
                }
              >
                <td>
                  <div className='text-wrapper'>
                    <div className='account-name-wrapper'>
                      {account.expanded ? (
                        <Collapse
                          onClick={e => {
                            e.stopPropagation()
                            account.expanded = false
                          }}
                        />
                      ) : (
                        <Expand
                          onClick={e => {
                            e.stopPropagation()
                            account.expanded = true
                          }}
                        />
                      )}
                      <p
                        className='account-name'
                        onClick={() => {
                          account.expanded = !account.expanded
                        }}
                      >
                        {account.companyName}
                      </p>
                    </div>
                  </div>
                </td>
                <td>
                  <span className='text-wrapper'>{account.country}</span>
                </td>
                <td>
                  <span className='text-wrapper'>
                    {account.atheneumOffice.name}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper'>
                    {account.openProjectCount}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper'>
                    {account.activeContractCount}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper'>
                    {account.operationalGuidelines ? <Check /> : <Dash />}
                  </span>
                </td>
              </tr>
              {account.expanded && this.renderOffices(account)}
            </tbody>
          )
        })}
      </table>
    )
  }
}

export default inject('sidebarStore')(observer(AccountsOfficesTable))
